// extracted by mini-css-extract-plugin
module.exports = {"outroPage":"OutroPage_outroPage__3cwvz"};